export default {
  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  },

  setBookingReservationsStatuses: (state, bookingReservationsStatuses) => {
    state.bookingReservationsStatuses = bookingReservationsStatuses;
  }
};
